/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="84.86"
        height="95.6"
        viewBox="0 0 84.86 95.6"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M17 25.5a1 1 0 0 1 1.45 1.38 23.23 23.23 0 0 0-2.45 3.1 31.16 31.16 0 0 0-3.08 5.84q-.42 1.05-.69 1.92l-.15.48-.06.22a1.042 1.042 0 1 1-2.02-.51l.11-.37.13-.43c.2-.62.45-1.31.75-2a33.09 33.09 0 0 1 3.27-6.22A26.42 26.42 0 0 1 17 25.5ZM66.92 26.28a1 1 0 0 1 1.41 0 24.69 24.69 0 0 1 2.49 3.12 31.26 31.26 0 0 1 3.07 5.82c.22.56.41 1.09.58 1.57l.17.53.12.4v.18a1 1 0 0 1-.71 1.23 1 1 0 0 1-1.22-.72l-.11-.36-.09-.29c-.17-.54-.39-1.14-.65-1.79a28.7 28.7 0 0 0-2.86-5.45 24.11 24.11 0 0 0-2.29-2.86 1 1 0 0 1 .09-1.38Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M42.43 6.96C19 6.96 0 26.17 0 49.87a1.25 1.25 0 0 0 2.07.94 20.79 20.79 0 0 1 25.81 0l.1.08a1.25 1.25 0 0 0 1.59-.11h-.06c2.34-2 7.32-3.42 12.9-3.42s10.3 1.31 12.72 3.26l.29.24a1.18 1.18 0 0 0 1.57-.1v-.05l-.08.07a20.79 20.79 0 0 1 25.81 0 1.25 1.25 0 0 0 2.07-1v-.69C84.48 25.77 65.61 6.96 42.43 6.96Zm.65 2.54a40.15 40.15 0 0 1 39.2 37.76v.12l-.31-.2a24.23 24.23 0 0 0-12.08-3.33h-.46a23.75 23.75 0 0 0-13.24 4.4l-.19-.06c-3-2.06-8.08-3.3-13.59-3.3H42c-5.32.07-10.15 1.3-13.11 3.3l-.13.09A23.71 23.71 0 0 0 15 43.82h-.46a24.35 24.35 0 0 0-11.63 3.32l-.31.2v-.14A40.13 40.13 0 0 1 42.43 9.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M41.47 7.42a1.25 1.25 0 1 1 1.93 1.59C33.74 20.74 30 35.63 30 49.88a1.26 1.26 0 0 1-1.26 1.24 1.24 1.24 0 0 1-1.24-1.25c0-14.78 3.87-30.19 13.97-42.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M41.64 7.25a1.24 1.24 0 0 1 1.76.17c10.09 12.26 14 27.67 14 42.45a1.25 1.25 0 0 1-2.5 0c0-14.25-3.78-29.14-13.44-40.87a1.24 1.24 0 0 1 .18-1.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M42.43 0a1.26 1.26 0 0 1 1.25 1.12v7.09a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 42.43 0ZM42.43 44.89a1.26 1.26 0 0 1 1.25 1.12v37.95a11.63 11.63 0 1 1-23.26 0 1.25 1.25 0 0 1 2.5 0 9.131 9.131 0 0 0 18.26.27V46.14a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'UmbrellaIcon';

export default Icon;
